const initialState = {
  idatendimento: null,
  textMessage: [],
  contactId: null,
  infoUsers: null,
};

const messageFromHelpSideContent = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_MESSAGE_FROM_HELP_SIDE_CONTENT":
      return {
        idatendimento: action.idatendimento,
        textMessage: action.textMessage,
        contactId: action.contactId,
        infoUsers: action.infoUsers,
      };
    default:
      return state;
  }
};

export default messageFromHelpSideContent;
